module.exports = __webpack_public_path__ + "static/media/D7.2fa06443.png";